import { gql } from 'graphql-request'

export const GET_GIFT_FIRST = gql`
  query GET_GIFT_FIRST(
    $id: Int
    $name: String
    $description: String
    $country: String
    $value: Int
    $allowedCombos: String
    $isLuck: Boolean
    $giftTypeId: Int
    $giftEventId: Int
    $isPackage: Boolean
    $animationSpeedCenter: Int
    $animationSpeedSeat: Int
    $widthAnimation: Int
    $heightAnimation: Int
    $isAnimated: Boolean
    $active: Boolean
    $deleted: Boolean
    $typeFilterCreatedAt: TypeFilter
    $createdAtInitial: String
    $createdAtFinal: String
  ) {
    getGiftFirst(
      id: $id
      name: $name
      description: $description
      country: $country
      value: $value
      allowedCombos: $allowedCombos
      isLuck: $isLuck
      giftTypeId: $giftTypeId
      giftEventId: $giftEventId
      isPackage: $isPackage
      animationSpeedCenter: $animationSpeedCenter
      animationSpeedSeat: $animationSpeedSeat
      widthAnimation: $widthAnimation
      heightAnimation: $heightAnimation
      isAnimated: $isAnimated
      active: $active
      deleted: $deleted
      typeFilterCreatedAt: $typeFilterCreatedAt
      createdAtInitial: $createdAtInitial
      createdAtFinal: $createdAtFinal
    ) {
      error
      status
      data {
        active
        allowedCombos
        animationSpeedCenter
        animationSpeedSeat
        country
        createdAt
        dateLastActive
        dateLastDelete
        deleted
        description
        giftEvent {
          id
          name
        }
        giftEventId
        giftType {
          id
          name
        }
        giftTypeId
        heightAnimation
        iconGift
        id
        imgGift
        isGiftQuick
        isAnimated
        isLuck
        isPackage
        name
        updatedAt
        value
        widthAnimation
      }
    }
  }
`

export const GET_GIFTS = gql`
  query GET_GIFTS(
    $take: Int
    $skip: Int
    $giftTypeId: Int
    $giftEventId: Int
    $isPackage: Boolean
    $isLuck: Boolean
    $active: Boolean
    $deleted: Boolean
  ) {
    getGifts(
      take: $take
      skip: $skip
      giftTypeId: $giftTypeId
      giftEventId: $giftEventId
      isPackage: $isPackage
      isLuck: $isLuck
      active: $active
      deleted: $deleted
    ) {
      error
      status
      totalPages
      data {
        id
        name
        description
        value
        allowedCombos
        imgGift
        isLuck
        isGiftBox
        isCoinDrop
        isGallery
        isGiftQuick
        isOpenModal
        animationSpeedCenter
        animationSpeedSeat
        animationMediaGift
        animationAlphaLayoutPosition
      }
    }
  }
`
